import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import Home from './Home'; // Main dashboard
import AccessGate from "./AccessGate";
import QuotationGenerator from './QuotationGenerator'; // 👉 Invoice page
import App from './App'; // 👉 VCard
import PassportPhotoLayoutGenerator from './PassportPhotoLayoutGenerator';
import BooksPdfComposer from './BooksPdfComposer';
import CoverPage from './CoverPage';
import OffsetBooksPdfComposer from './OffsetBooksPdfComposer';
import OffsetCoverPage from './OffsetCoverPage';
import StickerKissCutStudio from './StickerKissCutStudio';
import PdfStickerGridDetector from './PdfStickerGridDetector';
import SheetToPDF from './label-generation/SheetToPDF';
import CustomLabelPage from './label-generation/custom/CustomLabelPage';
import PersonalizedLabelsApp from './personalized-labels/PersonalizedLabelsApp';
import PersonalizedBulkPage from './personalized-bulk/PersonalizedBulkPage';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AccessGate>
      <Routes>

        {/* ✅ Home Page */}
        <Route path="/" element={<Home />} />

        {/* ✅ Invoice (Default main page) */}
        <Route path="/invoice" element={<QuotationGenerator />} />

        {/* ✅ Other Pages */}
        <Route path="/vcard" element={<App />} />
        <Route path="/photos" element={<PassportPhotoLayoutGenerator />} />
        <Route path="/books" element={<BooksPdfComposer />} />
        <Route path="/coverpage" element={<CoverPage />} />
        <Route path="/offset-books" element={<OffsetBooksPdfComposer />} />
        <Route path="/offset-cover" element={<OffsetCoverPage />} />
        <Route path="/kisscut" element={<StickerKissCutStudio />} />
		<Route path="/labelkisscut" element={<PdfStickerGridDetector />} />

        {/* Label Generation */}
        <Route path="/label-generation" element={<SheetToPDF />} />
        <Route path="/label-generation/custom" element={<CustomLabelPage />} />
        <Route path="/personalized-labels/*" element={<PersonalizedLabelsApp />} />
        <Route path="/personalized-bulk" element={<PersonalizedBulkPage />} />
      </Routes>
      </AccessGate>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
